import React from 'react';

import { ChartsHeader } from '../../components';
import LineChartEDAratingTrend from '../../components/Charts/LineChartEDAratingTrend';

const LineEDAratingTrend = ({ 
  AItype = '', colors = [], fontsize = 12, id = '', intent = '', chartTpye }) => (
  <div className="p-2 md:p-2 bg-white rounded-3xl">
    <div className="w-full px-8">
      <LineChartEDAratingTrend 
        AItype={AItype} 
        colors={colors} 
        fontsize={fontsize} 
        id={id} 
        intent={intent} 
        chartTpye={chartTpye}
      />
    </div>
  </div>
);
export default LineEDAratingTrend;
